<template>
	<div class="p-m-5">
		<div>
			<h1>Welcome to the Review Wizard!</h1>
			<p>
				To start making changes, simply select a section from the left hand side
				and begin filling it in
			</p>
		</div>
		<!--<div v-else>
			<h1>Loading project...</h1>
		</div>-->
	</div>
</template>

<script>
export default {
	name: "ViewHome"
	/*computed: {
		projectId() {
			console.log("rrr:", this.$store.state.projectId);
			return this.$store.state.projectId;
		}
	}*/
};
</script>
